(() => {
  const root = document.querySelector('[data-bfp-page]');
  if (!root || root.dataset.bfpReady === 'true') return;
  root.dataset.bfpReady = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = document.querySelectorAll('[data-bfp-reveal]');
  const progress = root.querySelector('[data-bfp-progress]');
  const sticky = root.querySelector('[data-bfp-sticky]');
  const formTitle = document.getElementById('bfb-form-title');

  if (!reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('bfp-motion');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bfp-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -7% 0px' });
    reveals.forEach((item) => observer.observe(item));
  } else {
    reveals.forEach((item) => item.classList.add('bfp-visible'));
  }

  const updatePageState = () => {
    const start = root.offsetTop;
    const end = start + root.offsetHeight - window.innerHeight;
    const ratio = Math.min(1, Math.max(0, (window.scrollY - start) / Math.max(1, end - start)));
    if (progress) progress.style.transform = `scaleX(${ratio})`;

    if (sticky) {
      const pastHero = window.scrollY > start + Math.min(540, window.innerHeight * .65);
      const formVisible = formTitle && formTitle.getBoundingClientRect().top < window.innerHeight * .82;
      sticky.classList.toggle('bfp-sticky--visible', pastHero && !formVisible);
    }
  };

  let ticking = false;
  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(() => {
      updatePageState();
      ticking = false;
    });
  };

  updatePageState();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
})();
